module.exports = __webpack_public_path__ + "img/orange_022.329c1b0c.png";